const lightboxGalleries = [];

const lightboxGalleryLoadMore = (index) => {
	const { items, currentPage, itemsPerPage, galleryLength, loadMoreButton } =
		lightboxGalleries[index];

	if (currentPage * itemsPerPage < galleryLength) {
		const offsetStart = currentPage * itemsPerPage;
		const offsetEnd = (currentPage + 1) * itemsPerPage;
		const itemsToShow = Array.from(items).slice(offsetStart, offsetEnd);

		itemsToShow.forEach((item) => {
			item.classList.remove('hidden');
		});

		if ((currentPage + 1) * itemsPerPage >= galleryLength) {
			loadMoreButton.disabled = true;
		} else {
			lightboxGalleries[index].currentPage++;
		}
	}
};

const lightboxGalleryInit = () => {
	const blocks = document.querySelectorAll(
		'.lightbox-gallery__thumbnails-wrapper'
	);
	if (blocks.length) {
		blocks.forEach((block, index) => {
			const items = block.querySelectorAll(
				'.lightbox-gallery__single-col'
			);
			const loadMoreButton = block.querySelector(
				'#lightbox-gallery-load-more'
			);
			const itemsPerPage = parseInt(
				block.getAttribute('data-items-per-page')
			);
			const galleryLength = parseInt(
				block.getAttribute('data-gallery-length')
			);
			if (loadMoreButton) {
				loadMoreButton.addEventListener('click', (event) => {
					lightboxGalleryLoadMore(index, event);
				});
			}
			lightboxGalleries.push({
				block,
				items,
				loadMoreButton,
				itemsPerPage,
				currentPage: 1,
				galleryLength,
			});
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		lightboxGalleryInit();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
